import React from "react";
import { WizardMedication } from "@/types/medication";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface FoodInstructionsStepProps {
  medication: WizardMedication;
  onChange: (medication: WizardMedication) => void;
}

export const FoodInstructionsStep = ({ medication, onChange }: FoodInstructionsStepProps) => {
  const foodOptions = [
    { value: 'before', label: 'Before meals', description: 'Take medication before eating' },
    { value: 'with', label: 'With meals', description: 'Take medication during meals' },
    { value: 'after', label: 'After meals', description: 'Take medication after eating' },
    { value: 'any', label: 'Any time', description: 'No specific food requirements' },
  ];

  return (
    <div className="space-y-2">
      <h3 className="text-base font-semibold mb-2">Food Instructions</h3>
      <RadioGroup
        defaultValue="any"
        value={medication.foodInstructions}
        onValueChange={(value) => onChange({ ...medication, foodInstructions: value })}
        className="grid grid-cols-2 gap-2"
      >
        {foodOptions.map((option) => (
          <div key={option.value} className="relative">
            <RadioGroupItem
              value={option.value}
              id={`food-${option.value}`}
              className="peer sr-only"
            />
            <Label
              htmlFor={`food-${option.value}`}
              className={cn(
                "flex flex-col h-full justify-center rounded-lg border-2 py-2 px-3 cursor-pointer transition-all",
                "hover:bg-slate-50",
                "peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-primary/5"
              )}
            >
              <p className="font-medium text-sm">{option.label}</p>
              <p className="text-xs text-muted-foreground">{option.description}</p>
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};